import styled from "styled-components";
import { media, theme } from "../../theme/theme";
import { LEFT_SIDE_MENU_WIDTH } from "../../layout/SideBarLayout/SidebarLayout.styles";

const MIDDLE_ITEM_HIDE_BR = 1300;

export const STBWRapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 0 0 18px;
    
    ${media.custom(theme.v3.layout.sidebarLayout.mobile)} {
        max-width: calc(100vw - ${LEFT_SIDE_MENU_WIDTH}px);
        height: 70px;
    }

    @media print {
        display: none;
    }

    > div {
        &:first-child {
            display: flex;
            align-items: center;
            margin-right: 10px;
            min-width: 0;

            ${media.custom(theme.v3.layout.sidebarLayout.mobile)} {
                margin-right: 30px;
            }  
        }

        &:nth-child(2) {
            flex-shrink: 0;
            display: none;

            ${media.custom(MIDDLE_ITEM_HIDE_BR)} {
                display: block;
            }
        }

        &:nth-child(3) {
            flex-shrink: 0;
            margin-left: 10px;

            ${media.custom(theme.v3.layout.sidebarLayout.mobile)} {
                margin-left: 30px;
            }  
        }
    }
`;

export const STBMobileRightSidePanel = styled.div`
    display: flex;
    align-items: center;

    > div {
        &:nth-child(2) {
            margin-right: 18px;
        }
    }
`;

const SettingTopBarBr = 1220;

export const SettingsTopBarTitle = styled.div<{ $useBorder?: boolean}>`
    display: flex;
    align-items: center;
    max-width: 100%;

    > div {
        &:first-child {
            padding-right: 15px;
            border-right:${({ theme,  $useBorder }) =>   $useBorder ?  `1px solid ${theme.v3.colors.grey88}` : ""};
            display: none;

            ${media.custom(SettingTopBarBr)} {
                display: flex;
                align-items: center;
            }
        }

        &:nth-child(2) {
            min-width: 0;

            ${media.custom(SettingTopBarBr)} {
                margin-left: 15px;
            }
        }
    }
`;